import React from "react";
import { useTranslation } from "react-i18next";
import { ContractStatus } from "../enums/contractStatus";

interface Props {
  status: ContractStatus;
}

const ContractStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation(["contracts\\enums\\contractStatus"]);

  switch (status) {
    case ContractStatus.Draft:
      return (
        <span className="badge badge-pill badge-info small font-weight-normal">
          {t(status)}
        </span>
      );
    case ContractStatus.Valid:
    case ContractStatus.Effective:
      return (
        <span className="badge badge-pill badge-success small font-weight-normal">
          {t(status)}
        </span>
      );
    case ContractStatus.Terminated:
    case ContractStatus.Canceled:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal">
          {t(status)}
        </span>
      );
    default:
      return null;
  }
};

export default ContractStatusLabel;
